module.exports = __webpack_public_path__ + "img/trafficgeneration.b61a90ff.webp";